// Lista completa de tari din lume (in romana)
export const COUNTRIES = [
  "Afghanistan","Africa de Sud","Albania","Algeria","Andorra","Angola","Antigua si Barbuda",
  "Arabia Saudita","Argentina","Armenia","Australia","Austria","Azerbaidjan",
  "Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgia","Belize","Benin",
  "Bhutan","Bolivia","Bosnia si Hertegovina","Botswana","Brazilia","Brunei","Bulgaria",
  "Burkina Faso","Burundi","Cambodgia","Camerun","Canada","Capul Verde","Cehia",
  "Chile","China","Cipru","Colombia","Comore","Congo (Brazzaville)","Congo (Kinshasa)",
  "Coreea de Nord","Coreea de Sud","Costa Rica","Croatia","Cuba","Danemarca",
  "Djibouti","Dominica","Ecuador","Egipt","El Salvador","Emiratele Arabe Unite",
  "Eritreea","Estonia","Eswatini","Etiopia","Fiji","Filipine","Finlanda","Franta",
  "Gabon","Gambia","Georgia","Germania","Ghana","Grecia","Grenada","Guatemala",
  "Guineea","Guineea Ecuatoriala","Guineea-Bissau","Guyana","Haiti","Honduras",
  "India","Indonezia","Iordania","Irak","Iran","Irlanda","Islanda","Israel","Italia",
  "Jamaica","Japonia","Kenya","Kiribati","Kosovo","Kuwait","Laos","Lesotho","Letonia",
  "Liban","Liberia","Libia","Liechtenstein","Lituania","Luxemburg","Madagascar",
  "Malawi","Malaysia","Maldive","Mali","Malta","Maroc","Marshall","Mauritania",
  "Mauritius","Mexic","Micronezia","Moldova","Monaco","Mongolia","Muntenegru",
  "Mozambic","Myanmar (Birmania)","Namibia","Nauru","Nepal","Nicaragua","Niger",
  "Nigeria","Norvegia","Noua Zeelanda","Olanda","Oman","Pakistan","Palau","Panama",
  "Papua Noua Guinee","Paraguay","Peru","Polonia","Portugalia","Qatar",
  "Republica Centrafricana","Republica Dominicana","Romania","Rusia","Rwanda",
  "Saint Kitts si Nevis","Saint Lucia","Saint Vincent si Grenadinele","Samoa",
  "San Marino","Sao Tome si Principe","Senegal","Serbia","Seychelles","Sierra Leone",
  "Singapore","Siria","Slovenia","Slovacia","Somalia","Spania","Sri Lanka","Sudan",
  "Sudan de Sud","Surinam","Suedia","Elvetia","Tajikistan","Tanzania","Thailanda",
  "Timor-Leste","Togo","Tonga","Trinidad si Tobago","Tunisia","Turcia","Turkmenistan",
  "Tuvalu","Ucraina","Uganda","Ungaria","Uruguay","Uzbekistan","Vanuatu",
  "Vatican","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe"
].sort();

export default COUNTRIES;
